const state = {
  fileList:[],
  uploadConfig:{},
}

const mutations = {
  setFileList (state,fileList) {
    state.fileList = fileList
  },
  setUploadConfig(state,uploadConfig){
    state.uploadConfig = uploadConfig
  }
}

const actions = {
  someAsyncTask ({ commit }) {
    // do something async
    commit('INCREMENT_MAIN_COUNTER')
  }
}

export default {
  state,
  mutations,
  actions
}
